import * as React from "react";
import { DataGrid, GridToolbar, frFR } from "@mui/x-data-grid";
import { Box, styled } from "@mui/material";

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  "& .highlight-row": {
    fontSize: "12px",
    cursor: "pointer",
    border: "none",
    backgroundColor: "#e8e8e8 !important",
  },
  "& .row-font": {
    fontSize: "12px",
    backgroundColor: "white",
    cursor: "pointer",
    border: "none",
    "&:hover": {
      backgroundColor: "#e8e8e8 !important",
    },
  },
  "& .MuiDataGrid-footerContainer": {
    backgroundColor: "white",
  },
  "& .MuiCircularProgress-root": {
    padding: 5,
    marginBottom: 4,
  },
  ".rowAction": {
    backgroundColor: "#e8e8e8",
    fontSize: "12px",
  },
}));

export default function TableCustomized({
  rows,
  totalElements,
  columns,
  pageSizeOptions,
  onClickRow,
  paginationMode = "server",
  paginationModel,
  setPaginationModel,
  customInitialState = null,
  initialState = {
    pagination: {
      paginationModel: {
        page: 0,
        pageSize: customInitialState ? customInitialState : 10,
      },
    },
  },
  loading = false,
  isSlots = true,
  isFooter = true,
  noDataHeight = "250px",
  cursor = "pointer",
  onRowEnter = null,
  onRowLeave = null,
  gridRef = null,
  highlightRowId,
  onColumnVisibilityChange,
  density = "standard",
  onDensityChange,
}) {
  const dataGridHeight = rows.length === 0 ? noDataHeight : "auto";
  return (
    <Box
      sx={{
        minHeight: "30%",
        height: "50%",
        width: "100%",
        "& .super-app-theme--header": {
          backgroundColor: "#e3e3e3",
          color: "#232f66",
          fontWeight: "bold",
          fontSize: "14px",
        },
        ".MuiDataGrid-root .MuiDataGrid-columnHeaderTitle": {
          fontWeight: "bold",
        },
      }}
      ref={gridRef}
    >
      <StyledDataGrid
        sx={{
          height: dataGridHeight,
          ".MuiDataGrid-row": {
            border: "none",
          },
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "& .row-font": {
            cursor: cursor,
            "&:hover": {
              backgroundColor: cursor === "pointer" ? "" : "white",
            },
          },
        }}
        onColumnVisibilityModelChange={onColumnVisibilityChange}
        density={density}
        onStateChange={(v) => {
          density !== v.density.value && onDensityChange(v.density.value);
        }}
        getRowClassName={(params) => {
          return `row-font ${
            params.id === highlightRowId ? "highlight-row" : ""
          }`;
        }}
        disableColumnMenu
        localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
        disableColumnFilter
        disableRowSelectionOnClick
        rows={rows}
        rowCount={totalElements}
        columns={columns}
        hideFooter={!isFooter}
        initialState={initialState}
        pageSizeOptions={pageSizeOptions}
        {...(isSlots && {
          slots: { toolbar: GridToolbar },
          slotProps: {
            toolbar: {
              printOptions: { disableToolbarButton: true },
              csvOptions: { disableToolbarButton: true },
            },
          },
        })}
        getRowId={(row) => row.id}
        onRowClick={onClickRow}
        paginationMode={paginationMode}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        loading={loading}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            csvOptions: { disableToolbarButton: true },
          },
          loadingOverlay: {
            sx: {
              backdropFilter: "blur(3px)",
            },
          },
          row: {
            onMouseEnter: onRowEnter,
            onMouseLeave: onRowLeave,
          },
        }}
      />
    </Box>
  );
}
